import React from 'react';
import HelpDeskTicketList from './HelpDeskTicketList';

export default function HelpDeskTeamTickets() {
  return (
    <HelpDeskTicketList
      title="My team's tickets"
      scope="team"
      emptyHint="Tickets opened or owned by your direct reports appear here when you have reportees."
    />
  );
}
